import { Model } from "@vuex-orm/core"
import StudentCourse from "@/models/StudentCourse"
import { notify } from "@/services/notification"

export default class Note extends Model {
  static get entity() {
    return "notes"
  }

  static fields() {
    return {
      id: this.attr(null),
      student_course_id: this.attr(null),
      content: this.attr(""),
      created_at: this.attr(""),
      updated_at: this.attr(""),
      student_course: this.belongsTo(StudentCourse, "student_course_id"),
      user_name: this.attr(""),
    }
  }

  static async getAll() {
    return await this.api()
      .get(`/notes`, { dataKey: "data" })
      .catch((error) => {
        notify("error", error)
        return error
      })
  }

  static async getAllStudentCourseNotes(studentCourseId) {
    return await this.api().get(`/notes/student-course/${studentCourseId}`, { dataKey: "data" })
  }

  static async createOne(data) {
    return await this.api()
      .post(`/notes`, data, {
        dataKey: "data",
      })
      .then(() => {
        notify("success", "Reussi")
      })
      .catch((error) => {
        notify("error", error.response.data.message)
      })
  }

  static async updateOne(id, data) {
    return await this.api()
      .put(`/notes/${id}`, data, {
        dataKey: "data",
      })
      .then(() => {
        notify("success", "Reussi")
      })
      .catch((error) => {
        console.log(error.response.data)
        notify("error", error.response.data.message)
      })
  }

  static async deleteOne(id) {
    return await this.api()
      .delete(`/notes/${id}`, {
        delete: id,
      })
      .then(() => {
        notify("success", "Reussi")
      })
      .catch((error) => {
        notify("error", error.response.data.message)
      })
  }
}
